import "./appLayout.scss";
function AppLayout({ children }) {
	return <div className="app-layout">{children}</div>;
}

export default AppLayout;
